<div Class="full-height flex justify-content-center align-items-center">
  <img src="./assets/gif/rocket-icon.gif" alt="Rocket Icon" />
</div>
